import Constants from '../Constants';
import { LocaleData } from './LocaleData';

export default {
    _LANGUAGE: Constants.language.PT,
    WELCOME: 'Bem-vindo ao',
    YOUR_EMAIL: 'Seu e-mail',
    PASSWORD: 'Senha',
    TYPE_YOUR_EMAIL: 'Digite seu e-mail',
    TYPE_YOUR_PASSWORD: 'Digite sua senha',
    ENTER: 'ENTRAR',
    TERMS_OF_USE: 'Termos de Uso',
    ACCEPT_TERMS: 'Li e concordo com os termos de uso',
    PROCESSING: 'Processando...',
    BEGIN: 'Começar',
    FORGOT_PASSWORD: 'Esqueceu sua senha?',
    FORGOT_PASSWORD_TITLE: 'Esqueci a minha senha',
    FORGOT_PASSWORD_CTA1: 'Calma! Vamos definir uma nova!',
    FORGOT_PASSWORD_CTA2: 'Digite seu e-mail no campo abaixo.',
    RESET_PASSWORD: 'Continuar',
    GO_BACK: 'Voltar',
    AUTHENTICATION_FAILED: 'Usuário e/ou senha incorretos!',
    RESET_PASSWORD_SUCCESS: 'E-mail de redefinição de senha enviado com sucesso!',
    RESET_PASSWORD_FAILED: 'Ocorreu um erro... Verifique o e-mail digitado e tente novamente!',
    RESET_PASSWORD_SUCCESS_TITLE: 'Enviamos um e-mail com as instruções necessárias!',
    RESET_PASSWORD_SUCCESS_CTA: 'Consulte seu e-mail e siga as orientações para definir sua nova senha!',
    UNDERSTAND: 'Entendi',
    EMPTY_ITEMS: 'Não tem itens por aqui!',
    ITEM: 'Item',
    ITEMS: 'Itens',
    LETS_START: 'Vamos começar?',
    CREATE_NEW_ITEM: 'Criar novo item',
    NEW_ITEM: 'Novo item',
    NEW: 'Novo',
    NEW_2: 'Nova',
    SELECT_MEDIA_TYPE: 'Selecione o tipo de mídia',
    VIDEO: 'Vídeo',
    AUDIO: 'Áudio',
    ARTICLE: 'Artigo',
    LINK: 'Link',
    PODCAST: 'Podcast',
    SELECT_LANGUAGE: 'Selecione o idioma',
    LANGUAGE: 'Idioma',
    LANGUAGE_PT: 'Português',
    LANGUAGE_EN: 'Inglês',
    CANCEL: 'Cancelar',
    ADVANCE: 'Avançar',
    HEADER: 'Capa',
    DROP_FILE_HERE: 'Solte seu arquivo aqui ou ',
    SEARCH_FILE: 'Procurar arquivo',
    ACCEPTED_IMAGE_FORMATS: '(Formatos aceitos: jpg e png)',
    ACCEPTED_FULL_IMAGE_FORMATS: '(Formatos aceitos: jpg, png, bmp e gif)',
    ACCEPTED_PNG_FORMAT: 'Formato aceito: png',
    ACCEPTED_IMAGE_EXTENSIONS: '(jpg, png)',
    ACCEPTED_VIDEO_FORMATS: '(Formatos aceitos: mp4 e mpeg4)',
    ACCEPTED_AUDIO_FORMATS: '(Formato aceito: mp3)',
    ACCEPTED_SUBTITLE_FORMATS: '(Formato aceito: vtt)',
    ACCEPTED_ZIP_FORMATS: '(Formatos aceitos: zip)',
    ACCEPTED_ATTACHMENTS_FORMATS: '(Formatos aceitos: pdf, ppt, xls, jpg, png, gif, mp3, mp4 e mpeg4)',
    ACCEPTED_DOCUMENT_FORMATS: '(Formatos aceitos: pdf, doc, docx, ppt, pptx, xls, xlsx)',
    TITLE: 'Título',
    AUTHOR: 'Autor',
    ESTIMATED_CONSUMPTION_TIME: 'Tempo estimado de consumo (em minutos)',
    ESTIMATED_TIME: 'Tempo estimado',
    CATEGORY: 'Categoria',
    CATEGORIES: 'Categorias',
    CATEGORY_MANAGEMENT: 'Gerenciar as categorias',
    CATEGORY_MANAGEMENT_DESCRIPTION: 'Antes de criar uma categoria, verifique se ela já existe no sistema.',
    CATEGORY_MANAGEMENT_ADD_NEW_CATEGORY: 'Criar nova categoria',
    CATEGORY_MANAGEMENT_INSERT_CATEGORY_NAME_PT: 'Insira o nome da categoria em português',
    CATEGORY_MANAGEMENT_INSERT_CATEGORY_NAME_EN: 'Insira o nome da categoria em inglês',
    CATEGORY_MANAGEMENT_SEARCH_BOX_PLACEHOLDER: 'Buscar uma categoria',
    CATEGORY_MANAGEMENT_FILTER_INACTIVE: 'Inativas',
    CATEGORY_MANAGEMENT_LIST_EMPTY: 'Não tem categorias por aqui.',
    CATEGORY_MANAGEMENT_INACTIVE_LIST_EMPTY: 'Não tem categorias inativadas por aqui.',
    CATEGORY_MANAGEMENT_SYSTEM_TOOLTIP: 'Categoria original do sistema.',
    CATEGORY_MANAGEMENT_PREFIX_SUCCESS_MSG: 'A categoria',
    CATEGORY_MANAGEMENT_SUFIX_SUCCESS_MSG: 'foi adicionada com sucesso!',
    CATEGORY_MANAGEMENT_CATEGORY_FOUND_ERROR_MSG: 'Esta categoria já existe no sistema.',
    CATEGORY_MANAGEMENT_GENERIC_ERROR_MSG: 'Ocorreu um erro ao tentar criar uma nova categoria.',
    CATEGORY_MANAGEMENT_COULD_NOT_INACTIVATE_CATEGORY_TITLE: 'Não foi possível inativar a categoria.',
    CATEGORY_MANAGEMENT_COULD_NOT_INACTIVATE_CATEGORY_MSG:
        'Foram identificados um ou mais conteúdos vinculados a esta categoria. Remova o vínculo antes de inativá-la.',
    ADD_CATEGORY: '+ Adicionar outra categoria',
    ACTIVATE_CATEGORY_TITLE: 'Reativar categoria',
    REACTIVATE_CATEGORY_TITLE: 'Reativar categoria',
    REACTIVATE_CATEGORY_MSG: 'Existe uma categoria inativa com este nome. Deseja reativa-la agora?',
    ACTIVATE_CATEGORY_DESCRIPTION_PREFIX: 'A categoria',
    ACTIVATE_CATEGORY_DESCRIPTION_SUFIX: 'será reativada. Deseja continuar?',
    INACTIVATE_CATEGORY_TITLE: 'Inativar categoria',
    INACTIVATE_CATEGORY_DESCRIPTION_PREFIX: 'A categoria',
    INACTIVATE_CATEGORY_DESCRIPTION_SUFIX: 'será inativada. Deseja continuar?',
    ACTIVATE_SUCCESS_PREFIX: 'A categoria',
    ACTIVATE_SUCCESS_SUFIX: 'foi reativada!',
    INACTIVATE_SUCCESS_PREFIX: 'A categoria',
    INACTIVATE_SUCCESS_SUFIX: 'foi inativada!',
    ACTIVATE_FAILURE_PREFIX: 'A categoria',
    ACTIVATE_FAILURE_SUFIX: 'não foi ativada!',
    INACTIVATE_FAILURE_PREFIX: 'A categoria',
    INACTIVATE_FAILURE_SUFIX: 'não foi inativada!',
    TAGS: 'Tags',
    CONTENT: 'Conteúdo',
    SAVE: 'Salvar',
    SAVE_ADD_QUESTION: 'Salvar e Adicionar nova questão',
    COURSE_ONLINE: 'Curso on-line',
    TEXT_COURSE_ONLINE: 'Treinamento que pode ser realizado a qualquer dia e horário, sem a presença de uma pessoa facilitadora.',
    TEXT_WORKSHOP: 'Treinamento ao vivo, ministrado por uma pessoa facilitadora e com dia, horário e local determinados.',
    WORKSHOP: 'Workshop',
    WORKSHOPS: 'Workshops',
    WORKSHOP_S: 'Workshop(s)',
    TYPE: 'Tipo',
    TYPE_HERE: 'Digite aqui',
    TYPE_TITLE: 'Digite o título',
    SELECT_AUTHOR: 'Selecione o autor',
    TYPE_AUTHOR: 'Digite o nome do autor',
    MIN_PLACEHOLDER: '10 minutos',
    SELECT_CATEGORY: 'Selecione a categoria',
    TYPE_TAG: 'Insira a(s) tag(s)',
    TYPE_TEXT: 'Digite seu texto',
    TYPE_INTRODUCTION: 'Digite uma introdução',
    URL_PLACEHOLDER: 'Insira o link aqui',
    INFOGRAPHIC: 'Infográfico',
    REMOVE: 'Remover',
    CONTENT_TYPE: 'Tipo de conteúdo',
    ABOUT: 'Sobre',
    ABOUT_INSERT: 'Insira uma breve descrição ',
    VIDEO_FILE: 'Arquivo de vídeo',
    AUDIO_FILE: 'Arquivo de áudio',
    HAS_SUBTITLES: 'Tem legenda?',
    PRIVATE: 'Privada',
    PUBLIC: 'Pública',
    FILTER: 'Filtrar',
    SEARCH: 'Buscar',
    EDIT: 'Editar',
    DELETE_ITEM: 'Excluir item',
    DELETE_LIST: 'Excluir lista',
    ALPHABETICAL_ORDER: 'Ordem alfabética',
    NEWLY_CREATED: 'Recém criado',
    TOP_RATED: 'Melhor avaliados',
    TIME: 'Tempo',
    IN_MINUTES: 'Em minutos',
    MEDIA_TYPE: 'Tipo de mídia',
    ORDER_BY: 'Ordene por',
    FILTER_BY: 'Filtre por',
    EMPTY_LIST: 'Não tem listas por aqui!',
    CREATE_NEW_LIST: 'Criar nova lista',
    CREATE_CATEGORY: 'Criar categoria',
    CATEGORY_PT_BR_LABEL: 'Português - PT-BR',
    CATEGORY_ING_LABEL: 'Inglês - ING',
    CATEGORY_SPA_LABEL: 'Espanhol - SPA',
    FILTER_BY_VISIBILITY: 'Filtrar por visibilidade',
    CLEAN_FILTER: 'Limpar filtro',
    LIST: 'Lista',
    CREATE: 'Criar',
    CONFIRM_EXIT: 'SIM, desejo SAIR',
    NO: 'Não',
    YES: 'Sim',
    LEAVE_SECTION_MESSAGE: 'Todas as informações serão apagadas. Deseja realmente sair?',
    ATTENTION: 'Atenção',
    CREATE_NEW_PLAYLIST: 'Criar nova lista',
    CREATED_AT: 'Criado em',
    CREATED_AT_PROGRAM: 'Criada em',
    LIST_ITEMS: 'Itens da lista',
    LIST_NO_ITEMS: 'Você ainda não adicionou itens à sua lista.',
    CHOOSE_ITEMS_BELOW: 'Escolha abaixo os itens.',
    LOCATE_AND_SELECT_ITEMS: 'Localizar e selecionar Itens',
    WE_FOUND: 'Encontramos',
    INCOMPATIBLE_ITEM: 'item incompatível',
    INCOMPATIBLE_ITEMS: 'itens incompatíveis',
    WITH_SELECTED_LANGUAGE: 'com o idioma selecionado.',
    HOME_HELLO: 'Olá',
    HOME_ORGANIZATION_HAS: 'Sua organização possui',
    HOME_REGISTERED_USERS: 'usuários cadastrados.',
    HOME_ACTIVE_USERS: 'usuários ativos.',
    EMPTY_PEOPLE: 'Você ainda não tem usuários cadastrados!',
    CREATE_NEW_PEOPLE: 'Adicionar novo usuário',
    NEW_PEOPLE: 'Novo usuário',
    ACTIVE: 'Ativo',
    REACTIVATE_ACTION: 'Reativar',
    INACTIVE: 'Inativo',
    INACTIVATE_ACTION: 'Inativar',
    DELETE_ITEM_CONFIRMATION: 'Deseja realmente excluir o item?',
    DELETE_LIST_CONFIRMATION: 'Deseja realmente excluir a lista?',
    DELETE_COURSE_CONFIRMATION: 'Deseja realmente excluir o curso?',
    LIST_CREATED_SUCCESSFULLY: 'Sua lista foi criada com sucesso.',
    ITEM_CREATED_SUCCESSFULLY: 'Seu item foi criado com sucesso.',
    ADD_ANOTHER_LANGUAGE: 'Deseja adicionar um outro idioma?',
    ADD_ANOTHER_LANGUAGE2: 'Adicionar outro idioma',
    CONFIRM_ADD_LANGUAGE: 'Sim, quero adicionar idioma',
    PROFILE_SELECT_CTA: 'Você possui dois perfis. Qual deles gostaria de acessar?',
    CHANGE_PROFILE: 'Alterar perfil de acesso',
    CHANGE_PASSWORD: 'Alterar senha',
    CHANGE_LANGUAGE: 'Alterar idioma',
    SEND_FEEDBACK: 'Enviar feedback',
    ACCESS_AS_ADMIN: 'Acessar como administrador',
    ACCESS_AS_USER: 'Acessar como usuário',
    CONFIRM_CHANGES: 'Confirmar redefinição',
    CHANGE_AND_CONTINUE: 'Alterar e continuar',
    CURRENT_PASS: 'Senha atual',
    NEW_PASS: 'Nova senha',
    REPEAT_PASS: 'Repita a nova senha',
    REPEAT_YOUR_NEW_PASS: 'Repita sua nova senha',
    CHANGE_PASS_SUCCESS: 'Senha alterada com sucesso!',
    CHANGE_PASS_FAILURE: 'Erro ao alterar a senha',
    WRITE_YOUR_MESSAGE: 'Escreva sua mensagem',
    YOUR_FEEDBACK: 'Seu feedback é muito importante para nós!',
    LISTS: 'Listas',
    AVAILABLE_SPOTS: 'Vagas disponíveis',
    LEAVE: 'Sair',
    FEEDBACK_SUCCESS: 'Feedback enviado com sucesso!',
    FEEDBACK_FAILURE: 'Erro ao enviar feedback',
    HOME: 'Início',
    MINE: 'Meus',
    MINE_PAGE: {
        FAVORITES: 'Favoritos',
        MY_CREATIONS: 'Minhas criações',
        COMPLETED: 'Concluídos',
    },
    CONFIGURATIONS: 'Configurações',
    USERS: 'Usuários',
    SUPPORT: 'Suporte',
    ARCHIVE_ITEM: 'Arquivar',
    ARCHIVE_ITEMS: 'Arquivadas',
    PUBLISHED: 'Publicados',
    PUBLISHED_PROGRAM: 'Publicadas',
    DRAFT: 'Em Rascunho',
    ARCHIVED: 'Arquivados',
    VISIBILITY: 'Visibilidade',
    ADMIN_USERS: 'Gerenciar Usuários',
    ADMIN_IMPORT_USERS: 'Histórico de importações',
    MAIL_FIRTS_ACCESS: 'E-mail de primeiro acesso',
    MAIL_FORGOT_PASSWORD: 'E-mail de redefinir senha',
    PASSWORD_REDEFINE: 'Redefinir senha',
    PUBLISH: 'Publicar',
    UNARCHIVE: 'Desarquivar',
    SAVE_AND_CLOSE: 'Salvar e fechar',
    ARCHIVE_ITEM_CONFIRMATION: 'Deseja realmente arquivar o item?',
    PUBLISH_ITEM_CONFIRMATION: 'Deseja realmente publicar o item?',
    UNARCHIVE_ITEM_CONFIRMATION: 'Deseja realmente desarquivar o item?',
    ARCHIVE_LIST_CONFIRMATION: 'Deseja realmente arquivar a lista?',
    PUBLISH_LIST_CONFIRMATION: 'Deseja realmente publicar a lista?',
    UNARCHIVE_LIST_CONFIRMATION: 'Deseja realmente desarquivar a lista?',
    A_PRODUCTION: 'Uma produção',
    LIST_EDIT: 'Edição da lista',
    AUDIO_TYPE_NAME: 'Podcast',
    DOCUMENT_CHANGE_LANGUAGE_LABEL: 'Texto',
    DOCUMENT_TYPE_NAME: 'Artigo',
    VIDEO_TYPE_NAME: 'Vídeo',
    HOURS: 'h',
    MINUTES: 'min',
    LATEST_PUBLISHED_LISTS: 'Acabaram de chegar',
    MOST_ACCESSED_LISTS: 'Mais acessadas',
    MOST_ACCESSED_LISTS_WHITELABEL: 'Mais acessados',
    IN_PROGRESS_LISTS: 'Em andamento',
    COMPLETED_LISTS: 'Concluído',
    TOP_RATED_LISTS: 'Melhores avaliações',
    LIKE_YOU_LISTS: 'Você também pode gostar',
    SEARCH_RESULT_LISTS: 'Resultados da busca',
    OTHER_COURSES: 'Outros cursos',
    ORGANIZATION_NOT_FOUND_TITLE: 'Página indisponível',
    ORGANIZATION_NOT_FOUND_MESSAGE: 'Essa página não está disponivel ou você não tem acesso a ela.',
    FIRST_ACCESS_EMAIL_SENT: 'E-mail de primeiro acesso enviado com sucesso para:',
    LIST_OF_CATEGORIES: 'Explore as categorias',
    ATTACHMENTS: 'Anexos',
    ATTACHMENT: 'Anexo',
    THERE_ARE_NO_ATTACHMENTS: 'Não há anexos',
    FAVORITES_PAGE: 'Meus favoritos',
    EMPTY_SECTION_MESSAGE: 'Esta seção está vazia.',
    COMPLETED_ITEM: 'Item concluído com sucesso.',
    LABEL_RATING_LESSON: 'Como você classifica este conteúdo?',
    WHAT_DID_YOU_THINK: 'O que você achou?',
    SELECT_AS_MANY_OPTIONS_AS_YOU_WANT: 'Selecione quantas opções quiser.',
    RATING_INSTRUCTION: 'Clique na quantidade de estrelas que representa sua classificação.',
    SUCCESS_REVIEW_MESSAGE: 'Avaliação realizada com sucesso!',
    ITEM_REVIEW: 'Avaliar Item',
    SEND_REVIEW: 'Enviar',
    COMMENT: 'Comentário',
    COMMENTS: 'Comentários',
    EMPTY_COMMENTS_SECTION: 'Não há comentários',
    ADD_COMMENT: 'Adicionar comentário',
    DURATION: 'Duração',
    COMMENT_PLACEHOLDER: 'Adicione aqui o seu comentário...',
    SYSTEM: 'Sistema',
    SYSTEM_CUSTOMIZATION: 'Personalizar o sistema',
    PRE_SAVED_CONTENT: 'Conteúdos pré-cadastrados',
    LABEL_RATING_COURSE: 'Como você classifica esse conteúdo?',
    EXTERNAL_LINK: 'Link externo',
    SEE_MORE_TEXT: 'Continuar',
    FOR_YOU_LISTS: 'Pra você',
    DATE: 'Data',
    TOTAL_RECORDS: 'Total Registros',
    TOTAL_PROCESSED: 'Total Processados',
    STATUS: 'Status',
    DETAILS: 'Detalhes',
    SEE: 'Ver',
    IN_PROGRESS: 'Em progresso...',
    CONCLUDED: 'Concluído',
    CONCLUDE: 'Concluir',
    CONCLUDED_ERROR: 'Concluído com erro',
    NAME: 'Nome',
    EMAIL: 'E-mail',
    DOWNLOAD_ERRORS: 'Baixar os erros',
    COMPLETED: 'Completo',
    COMPLETED_COURSE: 'Concluído',
    BLOCKED: 'Bloqueado',
    FAILED: 'Reprovado',
    INCOMPLETE: 'Em andamento',
    NOT_ATTEMPTED: 'Não iniciado',
    PASSED: 'Aprovado',
    COMPLETED_WITH_ERRORS: 'Completo com erros',
    STARTED: 'Iniciado',
    CREATED: 'Criado',
    EMPTY_IMPORT_HISTORY: 'Histórico de importações vazio',
    EMPTY_IMPORT_DETAIL: 'Detalhe de importação vazio',
    SUCCESS_WITH_EXCLAMATION: 'Sucesso!',
    ERROR: 'Erro',
    ERROR_MESSAGE: 'Mensagem de erro',
    CONTENTS: 'Conteúdos',
    ENROLLED: 'Matriculado',
    NOT_ENROLLED: 'Não matriculado',
    ENROLLED_IN_ANOTHER_CLASS: 'Matriculado em outra turma.',
    STUDENT_NAME: 'Nome do aluno',
    EXPIRES_IN: 'Expira em',
    EXPIRES: 'Expira',
    DAYS: 'Dias',
    DAY: 'Dia',
    TODAY: 'Hoje',
    UNTIL: 'Até',
    LABEL_RATING_PROGRAM: 'Como você classifica esta trilha?',
    SUCCESS_CLASSIFICATION_MESSAGE: 'Classificação realizada com sucesso!',

    COURSE_NOT_STARTED: 'Não iniciado',
    COURSE_STARTED: 'Em andamento',
    COURSE_EXPIRED: 'Expirado',
    COURSE_PASSED: 'Aprovado',
    COURSE_FAILED: 'Reprovado',
    COURSE_BLOCKED: 'Bloqueado',
    COURSE_COMPLETED: 'Concluído',
    PROGRAM_EXPIRED: 'Expirada',

    massImport: {
        MASS_ADD: 'Adicionar em massa',
        CHOSE_FILE: 'Escolher arquivo',
        TEMPLATE: 'Download do template',
        DOWNLOAD: 'Download de pessoas',

        PROCESSING: 'Estamos processando...',
        FEW_SECONDS: 'Esta operação podera levar alguns segundos.',

        NUMBER_USERS: 'O número de usuários',
        EXCEEDED_LIMIT: 'excedeu o limite de licenças disponíveis.',
        TOTAL_LICENCES: 'Você possui %n licenças',
        TOTAL_RECORDS: 'sua planilha possui %n registros.',
        PRECONDITION: 'Falha no envio',
        PRECONDITION_REV: 'Verifique se seu arquivo está correto ou preenchido e tente novamente',
    },

    toastMessages: {
        ADD_ITEM_TO_LIST_SUCCESS: 'Item adicionado à lista com sucesso',
        ADD_ITEMS_TO_LIST_SUCCESS: 'Itens adicionados à lista com sucesso',
        ADD_ITEMS_TO_LIST_ERROR: 'Houve um erro ao adicionar os itens à lista. Tente novamente',
        REMOVE_ITEM_FROM_LIST_SUCCESS: 'Item removido da lista com sucesso',
        REMOVE_ITEM_FROM_LIST_ERROR: 'Houve um erro ao remover o item da lista. Tente novamente',
        LESSON_SAVE_SUCCESS: 'Lição salva com sucesso',
        LESSON_SAVE_ERROR: 'Houve um erro ao salvar a lição. Tente novamente',
        LESSON_REMOVE_SUCCESS: 'Lição removida com sucesso',
        LESSON_REMOVE_ERROR: 'Houve um erro ao remover a lição. Tente novamente',
        LIST_SAVE_SUCCESS: 'Lista salva com sucesso',
        LIST_SAVE_ERROR: 'Houve um erro ao salvar a lista. Tente novamente',
        CONTENT_REMOVE_SUCCESS: 'Removido com sucesso',
        CONTENT_REMOVE_ERROR: 'Houve um erro ao remover. Tente novamente',
        LIST_PUBLISHED_SUCCESS: 'Publicado!',
        LIST_PUBLISHED_ERROR: 'Houve um erro ao publicar a lista. Tente novamente',
        LIST_ARCHIVED_SUCCESS: 'Lista arquivada com sucesso',
        LIST_ARCHIVED_ERROR: 'Houve um erro ao arquivar a lista. Tente novamente',
        PERSON_SAVE_SUCCESS: 'Pessoa salva com sucesso',
        CONFIGURATION_ERROR: 'Houve um erro ao salvar as configurações. Tente novamente',
        CONFIGURATION_SUCCESS: 'Configuração salva com sucesso',
        IMPORT_HISTORY_ERROR: 'Houve um erro ao buscar o histórico de importações. Tente novamente',
        UPDATE_SCORM_PACKAGE_IDENTIFIER_ERROR: 'Um ou mais identificadores de lição (SCO) do pacote enviado são diferentes do pacote original.​',
        UPDATE_SCORM_PACKAGE_SCOS_SIZE_ERROR: 'A quantidade de lições (SCOs) do pacote enviado é diferente do pacote original.',
        UPDATE_SCORM_PACKAGE_ERROR: 'Ocorreu um erro ao atualizar o pacote scorm.',
        FILE_TYPE_NOT_ALLOWED: 'Atenção! Arquivo não compatível. Utilize um dos formatos aceitos',
        SCORM_PACKAGE_PROCESS_SUCCESS: 'O pacote scorm foi processado com sucesso',
        SCORM_PACKAGE_PROCESS_ERROR: 'Houve um erro ao processar o pacote scorm',
        ADD_CONTENT_URL_ERROR: 'Houve um erro ao salvar o conteúdo. A Url não é válida.',
        QUESTION_REMOVE_ERROR: 'Houve um erro ao remover a questão. Tente novamente',
        ITEM_SAVE_SUCCESS: 'Item salvo com sucesso',
        ITEM_SAVE_ERROR: 'Houve um erro ao salvar o item. Tente novamente',
        GROUP_SAVE_SUCCESS: 'Grupo excluído com sucesso',
        GROUP_SAVE_ERROR: 'Houve um erro ao remover um grupo',
    },

    onboardingWhiteLabel: {
        WELCOME_TITLE: 'Boas-vindas à sua nova maneira de aprender!',
        WELCOME_DESCRIPTION: 'A seguir, confira um pouco do que você encontra por aqui.',
        PROTAGONISM_TITLE: 'Protagonismo e autonomia',
        PROTAGONISM_DESCRIPTION:
            'Acesse diversos conteúdos em diferentes formatos, de acordo com seus interesses e sua disponibilidade. Além disso, crie playlists para consumir individualmente ou compartilhar com a rede.',
        RECOMMENDATIONS_TITLE: 'Recomendações',
        RECOMMENDATIONS_DESCRIPTION:
            'Receba indicações de conteúdos baseadas nas suas preferências, no seu comportamento de consumo e nas preferências de pessoas com perfis similares ao seu.',
        VIRTUAL_PARTNER_TITLE: 'Parceira virtual',
        VIRTUAL_PARTNER_DESCRIPTION:
            'Você tem alguma dúvida, deseja atualizar seu mapa de aprendizagem ou quer buscar um conteúdo de forma mais personalizada? Fale com a Flô! Ela é sua parceira nessa jornada de aprendizagem.',
        FINAL_TITLE: 'Agora é com você!',
        FINAL_DESCRIPTION: 'Aproveite tudo o que a plataforma oferece. Boa jornada!',
    },

    PORTUGUESE: 'Português',
    ENGLISH: 'Inglês',
    CHANGE_LANGUAGE_TEXT:
        '<b>Atenção!</b> Certifique-se de que salvou todas as inclusões/alterações da página. Ao confirmar a <b>alteração de idioma</b>, todos os <b>dados que não foram salvos serão perdidos.</b>',
    AVAILABLE_LANGUAGES: 'Alterar idioma',
    ORIGINAL_LANGUAGE: 'Original',
    NON_EXISTENT_USER: 'O usuário é inexistente. Verifique se os dados estão corretos ou entre em contato com o suporte.',
    USER_NOT_REGISTERED: 'Seu e-mail não está cadastrado no sistema. Tente com outro endereço ou entre em contato com o suporte.',
    SEE_MORE_COMMENTS: 'Ver mais comentários (%n)',
    LISTS_WITH_THIS_CONTENT: 'Listas que também possuem esse conteúdo',
    LIST_WITH_THIS_CONTENT: 'Lista que também possui esse conteúdo',
    UNLIMITED: 'Ilimitadas',
    THE_FILE_IS_STILL_BEING_PROCESSED: 'O arquivo ainda está sendo processado',
    NO_MATCHES_FOUND: 'Nada encontrado',
    VIDEO_PROCESSING: 'Vídeo em processamento',
    WAIT_FEW_MINUTES: 'Aguarde alguns minutinhos...',
    RECENT_SEARCHES: 'Buscas recentes',
    CLEAR: 'Limpar',
    ADD_NEW_TAG: 'Adicionar nova Tag: ',
    REDIRECT_TO_HOME: 'Redirecionando para home em %s segundos...',
    VIEWS: 'Visualizações',
    GO_TO_HOME_PAGE: 'Ir para página inicial',
    PAGE_UNAVAILABLE: 'Página indisponível',
    TEXT_PAGE_UNAVAILABLE: 'Esta página não está mais disponível ou você não tem acesso a ela.',
    PASSWORD_CHECKLIST_UPPERLOWERCASE: 'Letras maiúsculas e minúsculas',
    PASSWORD_CHECKLIST_CHARACTERS: '%n caracteres',
    PASSWORD_CHECKLIST_SPECIAL_CHARACTERS: 'Caractere especial',
    PASSWORD_CHECKLIST_HAS_NUMBERS: 'Número',
    PASSWORD_CHECKLIST_TITLE: 'Sua senha deve conter no mínimo:',
    PASSWORD_CHECKLIST_SPECIAL_CHAR_EXAMPLES: 'exemplos: # ! @ & * $ =',
    PASSWORD_AND_CONFIRMATION_NOT_EQUAL: 'As senhas não coincidem.',
    INVALID_PASSWORD_FORMAT: 'Formato de senha inválido',
    INCORRECT_CURRENT_PASSWORD: 'Senha atual não confere',
    SAME_TITLE_IN_ANOTHER_RESULT: 'Este título já foi inserido em outro resultado.',
    NOTIFICATION_ALL: 'Todas',
    NOTIFICATION_UNREAD: 'Não lidas',
    WEEKS: 'semanas',
    NEWLY_ADDED: 'Recém cadastrados',
    OPS: 'Ops!',
    ERROR_WHILE_SAVE_DATA: 'Parece que tivemos um problema ao gravar seus dados.',
    TRY_AGAIN: 'Tentar novamente',
    ITEM_ADDED_TO_LIST: 'Item adicionado à lista.',
    ADD_TO_MY_LISTS: 'Adicionar às minhas listas',
    CHANGE_ITEM_LANGUAGE: 'Alterar idioma do item',
    SELECT_LISTS: 'Selecione uma lista',
    CHANGE: 'Alterar',
    MY_LISTS_EMPTY_SECTION: 'Você ainda não criou listas privadas',
    INSERT_LIST_NAME: 'Insira um nome para a lista',
    LIST_NAME: 'Nome da lista',
    LEAVE_ACTION_MESSAGE: 'Deseja cancelar?',
    LEAVE_ACTION_WARNING: 'Ao confirmar você estará cancelando a ação.',
    COURSE_HAS_CONTENT_ERROR: 'Não é possível selecionar uma lista que já contêm o item.',
    AVAILABLE_TO_ALL_ORGANIZATIONS: 'Permitir que todas as organizações visualizem o conteúdo publicado.',
    LMS: 'LMS',
    PLAYLIST: 'Playlist',
    BUZZ: 'Buzz',
    COURSES: 'Cursos',
    PROGRAMS: 'Trilhas',
    PROGRAM: 'Trilha',
    CREATE_NEW_COURSE: 'Criar novo curso',
    CREATE_NEW_PROGRAM: 'Criar nova trilha',
    CREATE_NEW_TEST: 'Criar novo teste',
    NEW_COURSE_SCORM_ALERT:
        'Este é o único momento para inserir o pacote scorm. Se optar por prosseguir ou salvar esta página, você não poderá mais incluir o arquivo. Deseja continuar?',
    COURSE_PUBLISH: ' Seu curso foi publicado com sucesso!',
    ATTENTION_COURSE_PUBLISHED:
        'Seu curso já pode ser utilizado na criação de trilhas. Gostaria de adicionar uma turma agora e disponibilizar o curso separadamente na plataforma?',
    CONFIRM_INSERT_SCORM: 'Não, Inserir SCORM',
    EMPTY_COURSE_LIST: 'Não tem cursos por aqui!',
    EMPTY_PROGRAM_LIST: 'Não tem trilhas por aqui!',
    EMPTY_TEST_LIST: 'Não tem testes por aqui!',
    STEP_OF: 'passo %n de %t',
    NEXT: 'Próximo',
    PREVIOUS: 'Anterior',
    SAVE_TO_DRAFT: 'Salvar em rascunho',
    GENERAL_INFORMATION: 'Informações gerais',
    LESSONS: 'Lições',
    CLASSES: 'Turmas',
    CLASS: 'Turma',
    CLASSES_LIST: 'Lista de Turmas',
    EMPTY_COURSE_CLASS_LIST: 'Nenhuma turma disponível!',
    CREATE_NEW_COURSE_CLASS: 'Utilize o menu ao lado para adicionar a primeira turma deste curso',
    NEW_COURSE: 'Novo Curso',
    EDIT_COURSE: 'Edição de Curso',
    NEW_PROGRAM: 'Nova trilha',
    EDIT_PROGRAM: 'Edição de trilha',
    DELETE: 'Excluir',
    ADD_A_HEADER: 'Adicione uma capa',
    HAS_PREREQUISITE: 'Possui pré-requisito.',
    ITS_MANDATORY: 'É obrigatório.',
    SAVE_HIGHEST_SCORE: 'Salvar maior nota',
    EVALUATION_BLOCKED_AFTER_APPROVAL: 'Bloquear após aprovação.',
    QUESTION_ALTERNATIVES_RANDOM_ORDER: 'Exibir alternativas em ordem aleatória.',
    SHOW_ANSWERS_AT_THE_END: 'Mostrar gabarito no fim da avaliação.',
    MINIMUM_SCORE_FOR_APPROVAL: 'Nota de Corte',
    EVALUATION_WEIGHT: 'Peso da Avaliação',
    INC_EVALUATION_WEIGHT: 'Incluir peso',
    INC_NUMBER_ATTEMPTS: 'Limitar tentativas',
    INC_TIME_LIMIT: 'Definir tempo',
    ADD_QUESTIONS: 'Adicionar Questões',
    QUESTIONS_ANSWERED: 'questões respondidas',
    QUESTION_ANSWERED: 'questão respondida',
    KNOWLEDGE_EVALUATION: 'Avaliação de Conhecimento',
    EXIT_EVALUATION: 'Sair da avaliação',
    EXIT_EVALUATION_TITLE: 'Você está saindo da avaliação!',
    EXIT_EVALUATION_CONFIRMATION: 'Ao clicar em sair, a avaliação será finalizada e você perderá a tentativa. Deseja prosseguir?',
    SELECT_ALTERNATIVE: 'Selecione uma alternativa',
    BACK_COURSE: 'Voltar ao curso',
    OF: 'de',
    WRITE_CONTEXT_HERE: 'Escreva seu enunciado aqui',
    CONTEXT_QUESTION: 'Enunciado da questão',
    ADD_QUESTION: 'Adicionar questão',
    EDIT_QUESTION: 'Editar questão',
    SAVE_EDITIONS: 'Salvar alterações',
    QUESTION_STATEMENT: 'Insira um enunciado para a questão',
    QUESTION_SAVE_SUCCESS: 'Questão salva com sucesso!',
    DELETE_QUESTION_MESSAGE: 'Você removerá essa questão da sua lista. Essa ação não pode ser revertida. Deseja continuar mesmo assim?',
    QUESTION_RETURN_MESSAGE: 'Você voltará para o quadro de lições e perderá todas as informações não salvas. Deseja continuar mesmo assim?',
    ALTERNATIVE: 'Alternativa',
    ADD_ALTERNATIVES_CHECK_CORRECT: 'Adicione as alternativas e marque a correta',
    ADD_ALTERNATIVE: 'Adicionar alternativa',
    SELECT_CORRECT_ALTERNATIVE: 'Selecione a alternativa correta',
    SELECT_CORRECT_ALTERNATIVES: 'Selecione as alternativas corretas',
    DELETE_ALTERNATIVE_MESSAGE: 'A questão deve ter pelo menos duas alternativas',
    BLANK_ALTERNATIVES: 'Existem alternativas em branco',
    NUMBER_OF_ATTEMPTS_ALLOWED: 'Número de tentativas',
    TIME_LIMIT: 'Tempo Limite',
    TOOLTIP_HAS_PREREQUISITE: 'Esta lição só estará disponível após a conclusão da lição anterior, marcada como obrigatória.',
    TOOLTIP_ITS_MANDATORY: 'Esta lição precisa ser concluída para conclusão do curso.',
    TOOLTIP_EVALUATION_BLOCKED_AFTER_APPROVAL: 'Bloqueia a avaliação caso o colaborador seja aprovado.',
    TOOLTIP_QUESTION_ALTERNATIVES_RANDOM_ORDER: 'Exibir as alternativas das questões de forma arbitrária para cada colaborador.',
    TOOLTIP_SHOW_ANSWERS_AT_THE_END: 'Mostra as respostas certas e erradas no final da avaliação.',
    TOOLTIP_EVALUATION_WEIGHT: 'Define um peso para a avaliação quando o curso possui 2 ou mais avaliações.',
    TOOLTIP_EVALUATION_MASTERYSCORE: 'Defina um valor no intervalo de 10 a 100',
    TOOLTIP_NUMBER_OF_ATTEMPTS_ALLOWED: 'Número máximo de tentativas no intervalo de 1 a 99.',
    TOOLTIP_TIME_LIMIT: 'Tempo máximo, em minutos, de realização da avaliação.',
    TOOLTIP_TAGS: 'As tags são herdadas do curso, você pode editá-las se precisar.',
    TOOLTIP_CATEGORY: 'As categorias são herdadas do curso, você pode editá-las se precisar',
    TOOLTIP_ITS_MANDATORY_TRAINING: 'Marque se este for um treinamento de conclusão obrigatória para esta turma.',
    OPTIONAL_INFO: 'Informações Opcionais',
    VISUALIZE: 'Visualizar',
    NO_TITLE: 'Sem título',
    NO_DESCRIPTION: 'Sem descrição',
    DEFAULT_AUTHOR: 'Sem autor',
    LESSON_BOARD: 'Quadro de lições',
    LESSON_NOT_STARTED: 'Não iniciada',
    EVALUATION: 'Avaliação',
    EVALUATIONS: 'Avaliações',
    ATTEMPTS: 'Tentativas',
    ATTEMPT: 'Tentativa',
    MASTERY_SCORE: 'Nota de corte',
    SCORE: 'Nota',
    START_EVALUATION: 'Iniciar Avaliação',
    EVALUATION_TIPS_1: 'Você está iniciando a avaliação de conhecimento. Para uma melhor experiência, pedimos que siga algumas boas práticas:',
    EVALUATION_TIPS_2: 'Ao iniciar a avaliação navegue até o fim, respondendo as perguntas.',
    EVALUATION_TIPS_3: 'Não se ausente da máquina com a avaliação aberta.',
    EVALUATION_TIPS_4: 'Não feche a avaliação para retornar depois. Isso vai contar como uma tentativa, mesmo se ela não for finalizada.',
    EVALUATION_TIPS_5: 'Reserve um tempo para que possa realizar a avaliação, sem interrupções.',
    QUESTIONS: 'Questões',
    QUESTION: 'Questão',
    QUESTION_NAVIGATION_CLICK: 'Clique sobre os números para ir a uma questão específica.',
    ANSWERED_QUESTION_HIGHLIGHTED: 'As questões respondidas estão em destaque.',
    SCORM_SCO_WARNING:
        'Antes de subir o novo pacote SCORM, certifique-se de que a quantidade de lições (SCOs) e seus identificadores são os mesmos do pacote original.',
    COURSE_DESCRIPTION: 'Ementa',
    INSERT_DESCRIPTION_TO_HELP: 'Insira uma descrição que ajude o aluno a entender o conteúdo do curso',
    SCORM_PACKAGE: 'Pacote Scorm',
    SCORM_PACKAGE_ALERT: 'Atenção! Este é o único momento para subir pacotes SCORM.',
    REMOVE_PACKAGE: 'Excluir pacote',
    UPDATE_PACKAGE: 'Subir pacote com atualização',
    MEDIA_VIDEO_ALERT: 'Atualizaremos automaticamente após upload da mídia vídeo.',
    ARTICLE_CONTENT: 'Conteúdo do Artigo',
    MEDIA_MINUTES_ALERT: 'Atualizaremos automaticamente após upload da mídia %s.',
    LESSON: 'Lição',
    LOADING: 'Carregando...',
    LESSON_DESCRIPTION_DISABLED_INFO: 'Atualizaremos automaticamente após a inserção do link.',
    EMPTY_LESSON_BOARD_TITLE: 'Seu quadro de lições ainda está vazio!',
    EMPTY_LESSON_BOARD_MESSAGE: 'Utilize o menu ao lado para adicionar algumas lições.',
    EMPTY_LESSON_COMMENT: 'Clique aqui para acessar a lição.',
    EMPTY_QUESTION_BOARD_TITLE: 'Nenhuma questão adicionada à avaliação',
    ALL_N_STUDENTS_ENROLLED: 'Todos os %n alunos matriculados',
    SCORM_PACKAGE_IN_PROCESS: 'Processando pacote scorm...',
    CLASS_TITLE: 'Título da turma',
    CLASS_TITLE_PLACEHOLDER: 'Digite um nome para a turma',
    CLASS_ID: 'ID da Turma',
    CLOSED: 'Fechada',
    ENROLLED_LIST: 'matriculados',
    START_DATE: 'Data de início',
    END_DATE: 'Data de fim',
    UNDEFINED: 'não definida',
    ENROLL_CONFIG: 'Configurações de matrícula',
    ENROLL_NAME: 'Nome da turma',
    CLOSED_CLASS: 'Turma fechada',
    ENROLLMENT: 'Matrículas',
    ENROLL: 'Matrícula',
    ENROLLED_STUDENTS: 'pessoas matriculadas',
    ENROLLED_STUDENT: 'pessoa matriculada',
    SHOW_ALL: 'Ver todos',
    VIEW_ALL: 'Ver todos',
    CLEAN_CLASS: 'Limpar turmas',
    ENROLL_STUDENTS: 'Matricular individualmente',
    MASS_ENROLL_STUDENTS: 'Matricular em lote',
    DEADLINE: 'Prazos',
    CLASS_PERIOD: 'Defina o período de realização da turma.',
    CLASS_PERIOD_TITLE: 'Período da turma',
    REALIZATION_OF_WORKSHOP: 'Encontro(s)',
    FROM: 'Das',
    TO: 'Às',
    START: 'Início',
    END: 'Fim',
    CHOOSE_START_DATE: 'Escolha a data de início',
    CHOOSE_END_DATE: 'Escolha a data de fim',
    END_DATE_INFO: 'A definição da data de fim é opcional.',
    CERTIFICATE: 'Certificado',
    AVAILABLE_ON_FINISH: 'Disponível ao concluir',
    CERTIFICATE_PREVIEW: 'Pré-visualizar o certificado',
    CERTIFICATE_PREVIEW_TITLE: 'Prévia do certificado padrão',
    SEARCH_FOR_STUDENT: 'Busque pelo nome dos alunos',
    SEARCH_FOR_COURSE: 'Buscar um curso',
    SHOW_CATEGORY_COURSE: 'Mostrando cursos da categoria:',
    ADD_COURSE: 'Adicionar',
    COURSE: 'Curso',
    CERTIFICATE_ALERT: 'Será emitido um </br> certificado-padrão do sistema.',
    PROGRAM_CERTIFICATE_ALERT: 'Um certificado-padrão do sistema será emitido. As trilhas abertas não emitem certificado.',
    READ_MORE: 'Ler mais',
    READ_LESS: 'Ler menos',
    BY: 'Até',
    SET_FULL_SCREEN: 'Tela cheia',
    UNSET_FULL_SCREEN: 'Voltar',
    SCORM_PACKAGE_PROCESSING_ALERT:
        'O pacote Scorm ainda está em processamento e essa tarefa pode demorar um pouco. Este curso já está salvo na aba de rascunho. Em alguns instantes tente publicá-lo novamente.',
    SCORM_PACKAGE_PROCESSING_ERROR_ALERT:
        'Encontramos um erro no processamento do pacote Scorm. Acesse a aba Informações Gerais e tente fazer o upload novamente.',
    DOWNLOAD_CERTIFICATE: 'Baixar o certificado',
    COMPLETED_COURSE_MESSAGE: 'Parabéns você já concluiu este curso!',
    COMPLETED_PROGRAM_MESSAGE: 'Parabéns você já concluiu esta trilha!',
    WITH_CERTIFICATION: 'Com certificação',
    WITH_CERTIFICATE: 'Com certificado',
    PROGRAM_WITH_CERTIFICATE: 'Trilha com certificado',
    FINISH: 'Finalizar',
    REQUIRED_FIELDS: 'campos obrigatórios',
    PROGRAM_STATUS_HINT: 'Defina o status fechado caso seu programa não vá receber alterações e suas turmas precisem gerar certificados.',
    INSERT_PROGRAM_DESCRIPTION_TO_HELP: 'Insira uma descrição que ajude o aluno a entender o conteúdo da trilha',
    PROGRAM_STATUS_OPEN: 'Trilha aberta',
    PROGRAM_STATUS_CLOSE: 'Trilha fechada',
    PROGRAM_DESCRIPTION: 'Descrição da Trilha',
    PROGRAM_CONTENT: 'Conteúdos da Trilha',
    PROGRAM_PUBLISH_MODAL_TITLE: 'Sua trilha foi criada com sucesso!',
    PROGRAM_PUBLISH_MODAL_SUBTITLE: 'Gostaria de adicionar uma turma agora?',
    QUESTIONNAIRE_RESULTS: {
        PASSED_MSG: 'Parabéns',
        NOT_PASSED_MSG: 'Que pena',
        YOU_WERE: 'Você foi',
        MALE_APPROVED: 'Aprovado',
        FEMALE_APPROVED: 'Aprovada',
        MALE_NOT_APPROVED: 'Reprovado',
        FEMALE_NOT_APPROVED: 'Reprovada',
        MESSAGE_LINE_1: 'Você precisava de {0}% e acertou {1}%',
        MESSAGE_LINE_2: 'Confira o seu gabarito ao lado.',
        RESPONSE_SUMMARY: 'Seu gabarito',
        TRY_AGAIN: 'Tentar novamente',
        BACK_TO_COURSE: 'Voltar ao curso',
        YOU_STILL_HAVE_X_ATTEMPTS: 'Voce ainda tem %n tentativas!',
        DO_YOU_WANT_TO_RETRY: 'Deseja refazer a avaliação?',
        DO_YOU_WANT_TO_GO_BACK_TO_COURSE: 'Deseja voltar para o curso?',
    },
    ONBOARDING: {
        MAKE_ME_QUESTIONS: 'Me faça perguntas',
        MAKE_ME_QUESTIONS_DESCRIPTION: 'Clique no botão Flô para falar comigo. Posso tirar suas dúvidas ou só bater um papo!',
        SMART_SEARCH: 'Busca inteligente',
        SMART_SEARCH_DESCRIPTION: 'Tentando achar algo específico? A busca não ajudou? Fale comigo e receba uma recomendação mais do que certeira!',
        LEARNING_MAP: 'Mapa de aprendizagem',
        LEARNING_MAP_DESCRIPTION: 'Trace uma meta de estudos e acompanhe seu progresso. Estarei aqui trazendo lembretes, incentivos e dicas!',
        TOPICS_OF_INTEREST: 'Temas de interesse',
        TOPICS_OF_INTEREST_DESCRIPTION: 'Esses são os temas atuais da plataforma. Marque quais você prefere:',
        BOT_YOU_HERE: 'Você por aqui?!',
        BOT_IM_CALLED: 'Olá! Me chamo',
        BOT_NAME: 'Flô',
        BOT_WHO_I_AM: 'Assistente virtual ou guia extra-dimensional?',
        BOT_HOW_CAN_I_HELP_YOU: 'Clique e veja como posso ajudar!',
        BOT_LETS_GO: 'Vamos lá',
        ACKNOWLEDGEMENT: 'Combinado!',
        ACKNOWLEDGEMENT_FEEDBACK: 'Cada feedback ajuda a melhorar a precisão com que os conteúdos são recomendados para você!',
        ACKNOWLEDGEMENT_REMINDER: 'Lembre-se: se quiser alterar seus Temas de Interesse, acesse as configurações em seu perfil.',
    },
    LEARNING_MAP: {
        WEEKLY_TIME_AVAILABLE: 'Tempo disponível para estudo semanal',
        FAVORITE_MEDIA: 'Mídias preferidas',
        LEARNING_ITEMS_CHARACTERISTICS: 'Características dos itens de aprendizagem',
        GET_SUGGESTIONS_BY_EMAIL: 'Receber sugestões de itens por e-mail',
        TIME_OF_THE_DAY_TO_GET_SUGGESTIONS: 'Você prefere receber dicas em qual período',
        LEARNING_MAP_EDIT_OVERWRITE_MESSAGE: 'Ao alterar os dados desta tela, os dados atuais da sua meta serão sobrepostos.',
        LEARNING_MAP_SUCCESS_ON_SAVE: 'Mapa de aprendizagem salvo com sucesso!',
        LEARNING_MAP_FAIL_ON_SAVE: 'Erro ao salvar mapa de aprendizagem. Por favor, tente novamente.',
        MORNING: 'Manhã',
        AFTERNOON: 'Tarde',
        EVENTING: 'Noite',
        GOAL: 'Meta',
        WEEKLY_GOAL: 'Meta semanal - até',
        MINUTES: 'Minutos',
        COMPLETED_ITEMS: 'itens concluídos',
        COMPLETED_ITEM: '1 item concluído',
    },
    VIEW_MY_PROFILE: 'Ver meu perfil',
    PROFILE_MENU: {
        TOPICS_OF_INTEREST: 'Temas de interesse',
        LEARNING_MAP: 'Mapa de Aprendizagem',
        CONFIGURATIONS: 'Configurações',
    },
    HELP_REFINE_RECOMMENDATIONS: 'Hey, me ajude a refinar ainda mais as minhas recomendações.',
    HELP_REFINE_RECOMMENDATIONS_EXPLANATION:
        'Você poderá alterar seus temas de interesse a qualquer momento. Após selecionar os temas, não esqueça de salvar as alterações.',
    SAVE_ITEMS_LIST_CONFIRMATION: 'Deseja salvar os novos itens adicionados à lista?',
    TOOLTIP_PROGRAM_COURSE_ITS_MANDATORY: 'Este curso precisa ser concluído para a conclusão da trilha.',
    USE_PROGRAM_COURSE_SEQUENCE_AS_PREREQUISITE: 'Utilizar cada conteúdo desta sequência como pré-requisito para o próximo.*',
    PREREQUISITE_RULE_EXCEPTION: '* Esta regra não inclui workshops.',
    PROGRAM_COURSE_LIST_EMPTY_STATE: 'Você ainda não adicionou nenhum curso ou avaliação à trilha',
    PROGRAM_COURSE_LIST_EMPTY_STATE_INSTRUCTION: 'Utilize o menu ao lado para adicionar alguns',
    CLICK_TO_DOWLOAD_APP: 'Clique aqui para baixar o app',
    CLICK_TO_ACCESS_APP: 'Clique aqui para acessar o app',
    SHOW_LESSONS: 'Mostrar lições',
    HIDE_LESSONS: 'Esconder lições',
    PUBLISHED_AND_CLOSED_PROGRAM_INFO: 'Esta trilha já está publicada e definida como fechada. Não é possível adicionar ou remover conteúdos.',
    BOT_AVAILABILITY: 'Sempre Disponível',
    BOT_GREETINGS: 'Olá',
    BOT_HOW_CAN_I_HELP_YOU_CHAT: 'No que eu posso te ajudar?',
    BOT_NAME: 'Flô',
    BOT_TYPE_YOUR_QUESTION: 'Digite a sua pergunta',
    BOT_CATEGORIES_SELECTED: 'categoria selecionada',
    LEARNING_GOAL: 'Meta de Aprendizado',
    WEEKLY: 'Semanal',
    BOT_CHIPS_SEND: 'Enviar',
    MORNING: 'Manhã',
    AFTERNOON: 'Tarde',
    NIGHT: 'Noite',
    NEW_QUIZ: 'Novo Teste',
    EDIT_QUIZ: 'Edição de Teste',
    QUIZ_RESULTS_TITLE: 'Vamos começar definindo os resultados',
    QUIZ_RESULTS_DESCRIPTION:
        'Insira abaixo quais serão os resultados finais do teste, isso facilita na hora de criar respostas que estejam vinculadas aos resultados.',
    INTRODUCTION: 'Introdução',
    INTRODUCTION_TIP: 'Com esse campo, você pode inserir uma introdução ao resultado',
    RESULT: 'Resultado',
    RESULTS: 'Resultados',
    NEW_QUIZ_RESULT: 'Novo Resultado',
    REMOVE_RESULT: 'Remover resultado',
    ADD_TIP: 'Adicionar dica',
    TIP: 'DICA',
    TEXT: 'Texto',
    IMAGE: 'Imagem',
    GENERAL_DATA: 'Dados gerais',
    DESCRIPTION: 'Descrição',
    INSERT_QUIZ_DESCRIPTION_TO_HELP: 'Insira uma descrição explicando sobre o teste',
    OPEN_WHEN_ACCESSING_APPLICATION: 'Abrir automaticamente ao acessar o aplicativo',
    COMMUNICATE_USERS: 'Deseja comunicar os usuários?',
    SEND_NOTIFICATION_WHEN_QUIZ_PUBLISHED: 'Enviar uma notificação sobre o teste assim que for publicado?',
    ENTER_HERE_THE_RESULT: 'Digite aqui o resultado',
    ENTER_HERE_THE_DESCRIPTION_RESULT: 'Digite aqui a descrição do resultado',
    ENTER_HERE_THE_TIP_TEXT: 'Digite aqui o texto da dica',
    SHOW_VALUE: 'Mostre Valor',
    USERS_ENGAGE_MORE: 'Os usuários se engajam mais se entenderem que terão algum benefício participando da sua pesquisa!',
    I_GOT_IT: 'Entendi',
    INCREASE_ENGAGEMENT: 'Aumente o engajamento!',
    INCREASE_ENGAGEMENT_DESCRIPTION: 'Quando o usuário acessar o aplicativo, o teste já estará aberto, o que aumenta as chances de ser respondido.',
    WHEN_THIS_TEST_SHOULD_APPEAR: 'Quando este teste deve aparecer?',
    YOU_ALREADY_HAVE_A_TEST_AUTOMATICALLY_OPENING_IN_THE_APPLICATION: 'Você já possui um teste abrindo automaticamente no aplicativo:',
    ONLY_ONE_TEST_CAN_BE_OPENED_AUTOMATICALLY_AT_A_TIME: 'Apenas um teste pode abrir automaticamente por vez.',
    BACK: 'Voltar',
    FORWARD: 'Avançar',
    LAST_UPDATE: 'Última atualização: %s',
    SET_A_LEARNING_GOAL: 'Defina uma meta de aprendizado',
    LEARNING_GOAL_DESCRIPTION: 'Você pode inserir uma meta de tempo que deseja dedicar ao aprendizado por semana.',
    UNDERSTAND_YOUR_GOAL: 'Entenda sua meta',
    GOAL_HOW_TO_SUMMARY: 'Para atingir sua meta, você precisa concluir itens e lições. Saiba como:',
    GOAL_HOW_TO_ITEMS_DESCRIPTION: '<b>Itens:</b> clique em Concluir, após ver todo o conteúdo;',
    GOAL_HOW_TO_LESSONS_DESCRIPTION: 'Lições em <b>artigos, vídeos e áudios:</b> consuma, no mínimo, 70% do conteúdo;',
    GOAL_HOW_TO_EXTERNAL_LESSONS_DESCRIPTION: 'Lições em <b>link externo:</b> acesse o link.',
    GOAL_HOW_TO_CONCLUSION: 'Se sua meta não mudar imediatamente, não se preocupe! A atualização pode demorar algumas horas.',
    HISTORY_OF_THE_LAST_4_WEEKS: 'Histórico das últimas 4 semanas',
    WEEK_ONE: 'semana 1',
    WEEK_TWO: 'semana 2',
    WEEK_THREE: 'semana 3',
    WEEK_FOUR: 'semana 4',
    STUDY_TIME: 'Tempo de estudo',
    GOAL_OF_THE_WEEK: 'Meta da semana',
    MOST_VIEWED_CATEGORIES: 'Categorias mais vistas',
    NEW_LIST: 'Nova lista',
    WHAT_TRAINING_DO_YOU_WANT_TO_CREATE: 'Qual treinamento você deseja criar?',
    TITLE_OF_YOUR_LIST: 'Título da sua lista',
    TYPE_THE_TITLE: 'Digite o título',
    SHORT_DESCRIPTION: 'Breve descrição',
    TYPE_TAGS: 'Digite as tags',
    TAGS_INFO: 'As tags ajudam outros usuários a encontrarem sua lista',
    SUGGESTED_TAGS: 'Sugestões de tags',
    WOULD_YOU_LIKE_TO_ADD_CONTENTS_NOW: 'Gostaria de adicionar conteúdos agora?',
    SECTION_ACCORDION_SHOW: 'Exibir',
    SECTION_ACCORDION_SHOW_ALL: 'Exibir todos',
    SECTION_ACCORDION_HIDE: 'Ocultar',
    OK_GOT_IT: 'Ok, entendi',
    ESSENTIAL_SECTION: {
        ESSENTIAL: 'Essencial',
        ESSENTIALS: 'Essenciais',
        ESSENTIAL_TRAINING: 'Treinamento',
        ESSENTIAL_TRAININGS: 'Treinamentos',
        BANNER_TITLE: 'Não deixe para depois!',
        BANNER_INFO: 'Os treinamentos abaixo são <b>obrigatórios</b>. Não se esqueça de realizá-los, pois são bem importantes!',
        ABOUT_TO_EXPIRE: 'próximo de expirar',
        MANY_ABOUT_TO_EXPIRE: 'próximos de expirar',
    },
    MEDIAS: 'Mídias',
    HTML_TYPE_NAME: 'Artigo',
    INTERESTS_EDITION_SAVE_SUCCESS: 'Temas de interesse salvos com sucesso!',
    REMOVE_QUESTION: 'Remover questão',
    ADD_QUESTIONS_FOR_TEST: 'Adicione as questões do teste',
    ANSWER: 'Resposta',
    BELONGS_TO_RESULT: 'Pertence ao resultado',
    LESSON_STATEMENT: 'Enunciado',
    NEW_QUESTION: '+ Nova Questão',
    QUESTION_DESCRIPTION_IN_USE: 'Enunciado já está em uso',
    ENUNCIATION: 'Enunciado',
    SELECT_ONE_OPTION: 'Selecione uma opção',
    ENTER_HERE_THE_DESCRIPTION_QUESTION: 'Digite aqui a opção de resposta',
    WHY: 'Por quê',
    GOT_IT: 'Ok, Entendi',
    DISTRIBUTE_ANSWERS_PROPORTIONALLY: 'Distribua as respostas proporcionalmente',
    EACH_RESULT: 'Para cada resultado, insira um número igual, ou muito próximo de respostas',
    QUIZ_QUESTION_HINT: `<p>O nº de respostas que levam a cada resultado devem ser iguais, para que seu teste tenha resultados não enviesados.</p>
<p>
  Por exemplo: <br/>
  Seu teste tem 9 questões (<b>18 respostas</b>) e <b>3 resultados</b>. Isso significa que,
  <b>cada um dos resultados precisa estar vinculado a 6 respostas</b>.
</p>`,
    MANAGE: 'Gerenciar',
    REGISTERED: 'Cadastradas',
    AVAILABLE: 'Disponíveis',
    LICENCES: 'Licenças',
    NO_RESULTS_FOUND: 'Nenhum resultado encontrado.',
    RESULTS_WITHOUT_QUESTION: 'O(s) resultado(s) seguinte(s) não aparece(m) vinculado(s) a nenhuma resposta:',
    ADD_MORE_QUESTIONS_FOR_RESULTS: `<p><b>Adicione mais questões </b>para que todos os resultados estejam contemplados nas respostas.</p>`,
    BOT_LIKE_CONTENT_ADD_FAVORITE: 'Gostou? Quer adicionar o item a seus favoritos?',
    SUGGESTED_CONTENTS: {
        ADD_CONTENTS: 'Adicionar itens',
        NO_CONTENTS_ADDED: 'Não há conteúdos adicionados',
        WE_SELECTED_SOME_CONTENTS_FOR_YOU: 'Adicione os itens que selecionamos para você ou busque outros.',
        YOU_CAN_ALSO_ADD_MORE_CONTENTS: 'Adicione os itens que selecionamos para você ou busque outros.',
    },
    ADD: '+ Adicionar',
    ADDED_ITEM: 'adicionado',
    ADDED_ITEMS: 'adicionados',
    NO_RESULTS_FOR_SEARCH: 'Não existem resultados para a busca',
    EDIT_LIST: 'Editar lista',
    CONFIRM_MYLIST_DELETION: 'Deseja excluir a sua lista?',
    WARN_ON_DISCARD_CHANGES: 'As alterações serão descartadas.',
    WANT_TO_PROCEED: 'Deseja prosseguir?',
    UPDATE_MYLIST_ERROR: 'Ocorreu um erro ao gravar os seus dados',
    MANAGE_ITEMS: 'Gerenciar itens',
    CONFIRM_DELETION_ATTACHMENT_MESSAGE: 'Deseja excluir o anexo',
    RENAME: 'Renomear',
    RENAME_ATTACHMENT: 'Renomear anexo',
    NEW_ATTACHMENT_NAME: 'Novo nome do anexo',
    SAVE_EDITION: 'Salvar edição',
    ATTACHMENTS_AFTER_SAVING_LESON: 'Você poderá adicionar anexos após salvar a lição',
    ORDER_ATTACHMENTS_UPLOADED_MESSAGE: 'A ordem de upload dos anexos refletirá na ordem em que eles aparecem para o aluno',
    GENERAL: 'Geral',
    MANAGE_CLASSES: 'Gerenciar turmas',
    LIST_CREATED: 'Sua lista foi criada!',
    TEXT_ACCESS_MY_CREATIONS: 'Você pode acessar a lista em <strong>Meus</strong>, seção <strong>Minhas criações</strong>.',
    CHANGE_VISIBILITY: 'Selecione a visibilidade:',
    ONLY_ME: 'Somente eu',
    EVERYONE_IN_MY_ORGANIZATION: 'Todas as pessoas da minha organização',
    CHANGE_VISIBILITY_PUBLIC_ALERT:
        'Ao tornar sua lista <b>Pública</b>, você não poderá remover os itens dela, mesmo que altere a visibilidade para <b>Privada</b> novamente. Você poderá apenas adicionar novos itens ou excluir a lista.',
    FULL_NAME: 'Nome completo',
    DISPLAY_NAME: 'Nome exibido',
    ABOUT_ME: 'Sobre mim',
    POSITION: 'Cargo',
    EDIT_PROFILE: {
        EDIT_PROFILE: 'Editar perfil',
        DISPLAY_NAME_INFO:
            'O nome exibido pode ser seu nome ou um apelido. Pense em como quer que as pessoas encontrem você na plataforma. Se este campo ficar em branco, seu nome completo será exibido.',
        COMPANY_CHANGE_INFO: 'Para alterar alguma informação, você pode solicitar ao RH da sua empresa.',
    },
    SUCCESS_ON_SAVE: 'Alterações salvas com sucesso!',
    UPDATE_PHOTO: 'Alterar foto',
    USER_REGISTRATION: 'Cadastro de Usuário',
    TYPE_FULL_NAME: 'Digite o nome completo',
    TYPE_EMAIL: 'Digite o e-mail',
    TYPE_POSITION: 'Digite o cargo',
    DEPARTMENT: 'Departamento',
    TYPE_DEPARTMENT: 'Digite o departamento',
    TYPE_CPF: 'Digite o CPF',
    ERROR_REGISTER: 'Erro ao cadastrar',
    GENERIC_CONTACT_SUPPORT: 'Entre em contato com <strong>suporte.flow@afferolab.com.br</strong> e indique o erro <strong>[%s]</strong>.',
    LABEL_RATING_LMS_COURSE: 'Como você classifica este curso?',
    PUBLISHED_CONTENTS: 'Conteúdos publicados',
    NO_CONTENTS_YET: 'Ainda não há nenhum conteúdo',

    ACHIEVEMENTS: {
        ACHIEVEMENTS_TITLE: 'Conquistas',
        YOUR_CURRENT_PROGRESS_IS: 'Seu progresso atual é de',
        AVAILABLE_UNTIL: 'Disponível até',
        GRANTED_IN: 'Conquistado em',
        ACCESS_CERTIFICATE_AUTHENTICITY: 'Acessar certificado de autenticidade',
        ACCESS_ACHIEVEMENTS: 'Acessar Conquistas',
        DOUBTS: 'Dúvidas',
        NEWS: {
            TITLE_STEP_INTRODUCTION: 'Olá!',
            TITLE_STEP_ONE: 'Conquistas',
            TITLE_STEP_TWO: 'Badge',
            TITLE_STEP_THREE: 'Token',
            TITLE_STEP_FOUR: 'Regras e Prazos',
            TITLE_STEP_FIVE: 'E aí, despertei sua curiosidade? Embarque nessa com a gente!',
            SUBTITLE_STEP_INTRODUTIONS: 'Vim te contar uma novidade: agora você pode colecionar conquistas enquanto aprende!',
            SUBTITLE_STEP_ONE:
                'Para acelerar sua jornada de aprendizagem, trouxemos missões que, quando cumpridas, se tornarão conquistas! Seus esforços serão recompensados com badges e tokens.',
            SUBTITLE_STEP_TWO: 'É uma conquista local, ligada à nossa comunidade da plataforma. O badge disponível atualmente é o <b>Na área</b>.',
            SUBTITLE_STEP_THREE:
                'É um certificado digital registrado pela nossa parceira Hathor, especializada em blockchain. Ao conquistar o token, você passa a ter o registro permanente, podendo visualizá-lo e compartilhá-lo com sua rede profissional. Os tokens disponíveis são <b>No flow<b/>, <b>Curadoria</b> e <b>Conectividade</b>.',
            SUBTITLE_STEP_FOUR:
                'Clicando em cada badge ou token, você confere as regras das missões. Tenha atenção aos prazos das conquistas para não perder nenhuma delas!',
            BOT_LETS_GO: 'Vamos lá',
        },
    },

    BANNER_ORG_FOR_HOME_LABEL: 'Banner para home page',
    LOGO_ORG_LABEL: 'Logo da organização',
    MAX_SIZE: 'Tamanho máximo',

    CLOSE: 'Fechar',
    FOLLOW: 'Seguir',
    FOLLOWING: 'Seguindo',
    FOLLOWER: 'Seguidor',
    FOLLOWERS: 'Seguidores',
    DATA_PAGE: {
        DATA: 'Dados',
        DASHBOARD: 'Dashboards',
        REPORTS: 'Relatórios',
        GENERATE: 'Gerar',
        START_DATE: 'Data de Início',
        END_DATE: 'Data Fim',
        CONFIRM: 'Confirmar',
        REPORT_IN_PROCESS: 'Processando relatório...',
        REPORTING_HISTORY: 'Acessar histórico',
        GENERATED_ON: 'Gerado em {0} às {1}',
        ERROR: 'Erro!',
        DEFINE_THE_DATA_PERIOD: 'Defina o período dos dados',
        GENERATE_SUCCESS_MESSAGE: 'Em breve o relatório estará disponível.',
        GENERATE_ERROR_MESSAGE: 'Ocorreu um erro no processamento dos dados.',
        HISTORY: 'Histórico',
        HISTORY_ALERT: 'Atenção! Serão armazenados os últimos 5 relatórios gerados.',
        REPORT_PERIOD_MSG: 'Período do relatório {0} - {1}',
        GENERATED_ERROR: 'Em {0} às {1}',
        TRY_AGAIN: 'Tente novamente',
    },
    REVIEW: 'Avaliar',
    TOOLTIP_MARK_AS_DONE: 'Marque como concluído para adicionar este conteúdo à seção <b>Meus</b> e receber mais recomendações sobre esse tema',
    MARK_AS_DONE: 'Marcar como concluído',
    WHY_SHOULD_I_MARK_IT_AS_DONE: 'Por que devo marcar como concluído?',
    FAVORITE: 'Favorito',
    GENERAL_SETTINGS: 'Configurações gerais',
    THE_SCREEN_WILL_REFRESH_IN: 'A tela atualizará em',
    CLASS_TOTAL_RECORDS: 'Total de registros',
    SUCCESS: 'Sucesso',
    FAILURE: 'Falha',
    OPEN: 'Abrir',
    PROCESSING_IMPORT: 'Processando',
    IMPORT_COMPLETED: 'Processado',
    IMPORT_COMPLETED_WITH_ERROR: 'Processado com erro',
    CURRENT_PAGE: 'Página atual',
    ITEMS_PER_PAGE: 'Itens por página',
    SYSTEM_LANGUAGE: 'Idioma da plataforma',
    SYSTEM_LANGUAGE_INFO: 'Selecione o idioma de botões, textos e mensagens da plataforma.',
    CONTENT_LANGUAGE: 'Idioma de consumo dos conteúdos',
    CONTENT_LANGUAGE_INFO:
        'É possível selecionar mais de um idioma. As alterações serão refletidas nos itens, listas, cursos e trilhas. <b>Atenção:</b> somente aparecerão conteúdos no(s) idioma(s) selecionado(s).',
    WORKSHOP_TYPE: 'Tipo de workshop',
    WORKSHOP_TYPE_ONLINE: 'On-line',
    WORKSHOP_TYPE_IN_PERSON: 'Presencial',
    WORKSHOP_CLASS_PERIOD: 'Data e horário',
    WORKSHOP_CHOOSE_START_DATE: 'Data',
    WORKSHOP_CHOOSE_START_TIME: 'Hora de início',
    WORKSHOP_CHOOSE_END_TIME: 'Hora de fim',
    WORKSHOP_SELECTED_START_TIME: 'Hora de início',
    WORKSHOP_SELECTED_END_TIME: 'Hora de fim',
    WORKSHOP_ADDRESS: 'Endereço',
    WORKSHOP_ADDRESS_PLACEHOLDER: 'Insira o endereço onde o workshop vai acontecer',
    WORKSHOP_URL: 'Link da sala virtual',
    WORKSHOP_URL_PLACEHOLDER: 'Insira o link para ingressar na sala do workshop',
    WORKSHOP_INFORMATION: 'Informações',
    WORKSHOP_INSTRUCTOR: 'Nome de quem conduzirá o workshop',
    WORKSHOP_INSTRUCTOR_PLACEHOLDER: 'Insira o nome',
    WORKSHOP_TIME: 'Carga horária: ',
    WORKSHOP_TIPS_INFO: 'Informações extras para o workshop',
    WORKSHOP_TIPS_ALERT: 'Insira instruções breves. <b>Exemplo</b>: Leve seu computador pessoal para participar das dinâmicas.',
    WORKSHOP_ADD_TIPS_TITLE: 'Adicionar uma informação',
    WORKSHOP_TIPS_PLACEHOLDER: 'Insira uma informação',
    BRAZILIA_TIME: 'Horário de Brasília',
    WORKSHOP_LINK: '<b>Link da sala:</b>',
    DETERMINE_THE_CLASS_PERIOD:
        'Você precisa determinar o período de realização da turma e o dia em que o workshop acontecerá. </br> Confira um exemplo:',
    WORKSHOP_MODAL_CALENDAR:
        '<b>Atenção: </b> o dia de <b>realização do workshop</b> precisa ser agendado a partir da <b>data de início da turma e antes da data de fim</b> (caso esta seja determinada).',
    WORKSHOP_UNDERSTAND_DEADLINES: 'Entenda os prazos',
    WORKSHOP_CHECK_OUT_SOME_EXTRA_INFO: 'Confira algumas informações extras para o workshop:',
    WORKSHOP_MINISTERED_BY: '<b>Conduzido por:</b> ',
    WORKSHOP_WITH_CERTIFICATE: 'Workshop com certificado',
    CLASSES_TIPS_ALERT:
        'Quando você matricula ou desmatricula alguém, o sistema registra a ação automaticamente. Não é necessário clicar no botão <b>Salvar</b>.',
    ENROLLMENT_ITEM_ERRORS: {
        SUCCESS: 'Sucesso.',
        ALREADY_ENROLLED_IN_THE_CLASS: 'Já matriculado(a) na turma.',
        ALREADY_ENROLLED_IN_ANOTHER_CLASS: 'Já matriculado(a) em outra turma.',
        INVALID_EMAIL: 'O parâmetro informado não é um email válido.',
        PERSON_NOT_FOUND: 'Pessoa não encontrada.',
        INACTIVE_USER: 'Usuário inativo.',
    },
    WORKSHOP_ADD_NEW_MEETING_DAY: 'Adicionar mais um encontro',
    WORKSHOP_MEETING_DAY_NUMBER: '{0}º encontro',
    AT: 'Em',
    IN: 'Em',
    TRAINING_PAGE: {
        MENU: 'Treinamentos',
        TITLE: 'Confira aqui todos os treinamentos em que sua matrícula foi realizada.',
        DYNAMIC_TITLE: 'Trilhas e cursos',
    },
    SET_UP_WORKSHOP: 'Configurar workshop',
    WORKSHOPS_WITH_CONFLICT: 'Alguns agendamentos de workshop estão em conflito. Clique em <strong>Editar</strong> para verificar as informações.',
    SET_UP: 'Configurar',
    WORKSHOP_BEFORE_ANOTHER: 'Este workshop está agendado para acontecer antes do workshop <b>%s</b>.',
    WORKSHOP_SAME_DAY_AND_HOUR_ANOTHER: 'Este workshop está agendado para o mesmo dia e horário do workshop <b>%s</b>.',
    SOON: 'Em breve',
    INSERT_INVALID_LINK: 'Insira um link válido.',

    GO_TO_APP_OR_STORE_TITLE: 'Você está quase lá!',
    GO_TO_APP_OR_STORE_DESCRIPTION: 'Faça o download da plataforma para ter uma experiência completa de aprendizagem!',
    LOGO_OF_COMPANY: 'Logo da empresa',
    SCORM_CONFIRM_BACK_DIALOG: {
        TITLE: 'Salve seus dados de navegação',
        CONTENT: 'Antes de voltar, é preciso salvar as informações da sua navegação.',
        BUTTON_LABEL: 'Salvar',
    },
    QUESTIONS_SHOWN_IN_THE_ASSESSMENT: 'Questões mostradas na avaliação',
    DEFINE_NUMBER_OF_QUESTIONS:
        'Defina quantas questões serão mostradas para quem for responder à avaliação. Se você definir um número menor de questões do que o total de cadastradas, elas serão exibidas de forma aleatória.',
    ACCESS: 'Acessar',
    NEXT_LESSON: 'Próxima lição',
    GO_TO_LESSONS: 'Ir para lições',
    AMOUNT_REGISTERED_QUESTIONS: '%n/%t questões cadastradas.',
    DO_YOU_WANT_TO_CONFIGURE_NOW: 'Você quer configurá-los agora?',
    PROGRAM_WITH_NEW_WORKSHOP_WARNING: 'A trilha recebeu 1 ou mais novos workshops, e eles precisam ser configurados em cada turma.',
    WORKSHOP_NOT_CONFIGURED: 'Há 1 ou mais workshops não configurados nesta turma.',
    WORKSHOP_PUBLISHED: 'O workshop foi publicado!',
    ATTENTION_WORKSHOP_PUBLISHED:
        'Ele pode fazer parte de trilhas ou ser disponibilizado em separado. Você quer adicionar uma turma agora e disponibilizar o workshop separadamente?',
    CONTENT_FAMILY: 'Fámilia de conteúdo',
    SELECT_CONTENT_FAMILY: 'Seleciona uma família de conteúdo',
    DOCUMENT: 'Documento',
    CONFIRM_DOCUMENT_DOWNLOAD: 'Para concluir esta lição, é necessário baixar o arquivo. Deseja continuar?',
    SELECT_MULTIPLE_CHOICE_QUESTION_TYPE: 'Selecione o tipo de questão de múltipla escolha:',
    ONE_CORRECT_ANSWER: 'Uma resposta correta',
    MULTIPLE_CORRECT_ANSWERS: 'Múltiplas respostas corretas',
    YOU_HAVE_SELECTED_ALL_ALTERNATIVES: 'Você selecionou todas as alternativas.',
    ADD_THE_ALTERNATIVES_AND_SELECT_THE_CORRECT_ONE: 'Adicione as alternativas e selecione a correta:',
    ADD_THE_ALTERNATIVES_AND_SELECT_THE_CORRECT_ONES: 'Adicione as alternativas e selecione as corretas:',
    WILL_REMOVE_THE_TARGET_AUDIENCE: 'Deseja realmente excluir o público-alvo?',
    WHEN_DELETING_ENROLLED_USERS_THEY_WILL_NOT_BE_UNENROLLED: 'Ao excluir os usuários previamente matriculados não serão desmatriculados.',
    TARGET_NAME: 'Nome do público alvo',
    GROUP_EDIT: 'Edição de público alvo',
    GROUP_REGISTRATION: 'Cadastro de Público Alvo',
    CREATE_GROUP: 'Criar Público-alvo',
    CREATE_GROUP_SUCCESS: 'Publico alvo criado com sucesso',
    CREATE_GROUP_ERROR: 'Erro ao criar Público Alvo',
    RULE: 'Regra',
    GROUP_LIST: 'Lista de Públicos-alvo',
    MANAGER_GROUP: 'Gerenciar Público-Alvo',
    EMPTY_GROUP: 'Você ainda não tem regras de Público alvo criadas!',
    FIRST_NAME: 'Primeiro nome',
    LAST_NAME: 'Último nome',
    DEPARTAMENT_NAME: 'Departamento',
    INPUT: 'Campo',
    AND: 'E',
    OR: 'ou',
    CRITERIA: 'Critério',
    EQUAL: 'É igual',
    CONTAINS: 'Contém',
    ADD_CONDITION: 'Adicionar condição',
    CREATE_RULE: 'Criar regra',
    EDIT_MADE_TO_RULE_CAN_ENROLL_NEW_USERS_BUT_DOES_NOT_ENENROLL_ENROLLED_USERS:
        'Edições feitas na regra podem matricular novos usuários, porém não desmatricula usuários previamente matriculados',
    GROUP_EDIT_SUCCESS: 'Publico alvo editado com sucesso',
    GROUP_EDIT_ERROR: 'Erro ao editar público alvo',
    NAME_PUBLIC: 'Nome do público',
    CONDITION: 'Condições',
    SELECTED_PUBLIC_TARGET: 'Selecione o público-alvo',
    PUBLIC_TARGET: 'Público Alvo',
    AUTOMATIC_ENROLL: 'Matrícula automática',
    PUBLIC_ACTIVATED_IN_CLASS: 'Publico(s) ativado na turma!',
    PUBLIC_ADDED_TO_CLASS: 'Público adicionado na turma!',
    PUBLIC_REMOVE_CLASS: 'Público removido da turma ',
} as LocaleData;
